import { handleResponseError } from 'helpers/utils'
import { API } from './endpoint'
import { GetAgentListResponse, GetContactByIdResponse, CancelHandshakeInput, CancelHandshakeResponse, LoadAgentContactsResponse, LoadAgentContactsInput, AgentByIdResponse, GetAgentByIdResponse, AddAddressDataResponse, AddAddressDataInput, UpdateAddressDataInput, UpdateAddressDataResponse, RemoveAddressDataInput, RemoveAddressDataResponse, FindAgentInput, FindAgentResponse } from './interface'
import httpClient from '../axios/interceptors'
import { AxiosResponse } from 'axios'



export const getAgentsList = async (): Promise<GetAgentListResponse> => {
  const data: AxiosResponse<GetAgentListResponse> = await httpClient
    .get(API.getAgentsList)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getContactById = async (
  agentId: string
): Promise<GetContactByIdResponse> => {
  const data: AxiosResponse<GetContactByIdResponse> = await httpClient
    .get(API.getContactById + agentId)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getAgentById = async (
  agentId: string
): Promise<GetAgentByIdResponse> => {
  const data: AxiosResponse<GetAgentByIdResponse> = await httpClient
    .get(API.getAgentById + agentId)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const getRetailById = async (
  retailId: string
): Promise<GetAgentByIdResponse> => {
  const data: AxiosResponse<GetAgentByIdResponse> = await httpClient
    .get(API.getRetailById + retailId)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const cancelHandshake = async (
  input: CancelHandshakeInput
): Promise<CancelHandshakeResponse> => {
  const data: AxiosResponse<CancelHandshakeResponse> = await httpClient
    .post(API.cancelHandshake, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const loadAgentContacts = async (
  input: LoadAgentContactsInput
): Promise<LoadAgentContactsResponse> => {
  const data: AxiosResponse<LoadAgentContactsResponse> = await httpClient
    .post(API.loadAgentContacts, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const addAddressData = async (
  input: AddAddressDataInput
): Promise<AddAddressDataResponse> => {
  const data: AxiosResponse<AddAddressDataResponse> = await httpClient
    .post(API.addAddressData, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const updateAddressData = async (
  input: UpdateAddressDataInput
): Promise<UpdateAddressDataResponse> => {
  const data: AxiosResponse<UpdateAddressDataResponse> = await httpClient
    .post(API.updateAddressData, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const removeAddressData = async (
  input: RemoveAddressDataInput
): Promise<RemoveAddressDataResponse> => {
  const data: AxiosResponse<RemoveAddressDataResponse> = await httpClient
    .post(API.removeAddressData, input)
    .catch((error) => handleResponseError(error))
  return data.data
}

export const findAgentData = async (
  input: FindAgentInput
): Promise<FindAgentResponse> => {
  const data: AxiosResponse<FindAgentResponse> = await httpClient
    .post(API.findUser, input)
    .catch((error) => handleResponseError(error))
  return data.data
}